import z from "zod";

export const UserSchema = z.object({
  user_id: z.string().or(z.number()),
  name: z.string(),
  profile_photo_url: z.string(),
});

export const OptionsUserSchema = z.object({
  userId: z.string(),
  name: z.string(),
  profilePhotoUrl: z.string(),
});

export type IUser = z.infer<typeof UserSchema>;
export type IOptionsUser = z.infer<typeof OptionsUserSchema>;
